import type { LocaleCode } from "../types/locale-code";

import { getLocaleMetadata } from "../registry/locale-registry";

function getPrivacyPolicyUrl(localeCode: LocaleCode): string {
  const metadata = getLocaleMetadata(localeCode);

  return `${metadata.canonicalOrigin}${metadata.country.privacyPolicyPath}`;
}

export { getPrivacyPolicyUrl };
